module.exports = __webpack_public_path__ + "img/3active.95118cc0.png";